import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, CalendarHolidays, Resource } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  personalCalendarHolidays: Identifiable<CalendarHolidays>;
  retrievePersonalCalendarHolidays(
    request: Boundaries["retrievePersonalCalendarHolidays"]["request"],
  ): void;
}

function useRetrievePersonalCalendarHolidays(
  resource: Identifiable<Resource>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrievePersonalCalendarHolidaysRequestPending(resource),
    ),

    isRequestSuccess: useSelector(() =>
      selector.isRetrievePersonalCalendarHolidaysRequestSuccess(resource),
    ),

    isRequestFailure: useSelector(() =>
      selector.isRetrievePersonalCalendarHolidaysRequestFailure(resource),
    ),

    personalCalendarHolidays: useSelector(() =>
      selector.getPersonalCalendarHolidays(resource),
    ),
    retrievePersonalCalendarHolidays: core.retrievePersonalCalendarHolidays,
  };
}

export { useRetrievePersonalCalendarHolidays };
